module.exports = __webpack_public_path__ + "img/国防科技大学前沿交叉学院.390e1d2a.png";